var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"display":"flex"}},[_c('a-card',{staticClass:"wf-card wf-trans-card",attrs:{"bordered":false}},[_c('div',{staticClass:"wf-card-title"},[_c('img',{attrs:{"src":_vm.$_c + 'app/workflow/img/xwf/n2.gif'}}),_vm._v(" 已选择")]),_c('div',{staticClass:"wf-card-body"},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.result)}})])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }